import React from 'react';
import Placeholder from '@atlaskit/react-ufo/placeholder';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyComponent = lazyForPaint(() =>
	import(
		/* webpackChunkName: "jira-periscope-issue-view-development-field-suggestions" */ './index.tsx'
	).then((exportedModule) => exportedModule.IssueViewDevelopmentFieldSuggestions),
);

type Props = {
	issueId: string;
};

export const IssueViewDevelopmentFieldSuggestions = ({ issueId }: Props) => (
	<Placeholder name="jira-periscope-issue-view-development-field-suggestions" fallback={null}>
		<LazyComponent issueId={issueId} />
	</Placeholder>
);
